var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      _c("confirmDlg", { ref: "confirm" }),
      _c("messageDlg", { ref: "message" }),
      _c("loaderDlg", { ref: "loader" }),
      _vm.signedIn
        ? _c("RwNavigationDrawer", {
            scopedSlots: _vm._u(
              [
                {
                  key: "menu-content",
                  fn: function() {
                    return [_c("Menu")]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3356103596
            ),
            model: {
              value: _vm.drawerMenu,
              callback: function($$v) {
                _vm.drawerMenu = $$v
              },
              expression: "drawerMenu"
            }
          })
        : _vm._e(),
      _vm.signedIn
        ? _c("RwHeader", {
            scopedSlots: _vm._u(
              [
                {
                  key: "bar-nav-icon",
                  fn: function() {
                    return [
                      _c("v-app-bar-nav-icon", {
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.drawerMenu = !_vm.drawerMenu
                          }
                        }
                      }),
                      _c("img", { attrs: { src: _vm.logoFilename } }),
                      _c("v-spacer"),
                      [
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c(
                              "v-menu",
                              {
                                attrs: {
                                  "close-on-content-click": false,
                                  "nudge-width": 150,
                                  "offset-x": ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    color: "grey darken-2",
                                                    dark: ""
                                                  }
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$keycloak.tokenParsed
                                                      .name
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1028884854
                                )
                              },
                              [
                                _c(
                                  "v-list",
                                  [
                                    _c(
                                      "v-list-item",
                                      [
                                        _c(
                                          "v-list-item-avatar",
                                          [
                                            _c("v-icon", [
                                              _vm._v("fa-user-circle")
                                            ])
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$keycloak.tokenParsed
                                                      .name
                                                  ) +
                                                  " "
                                              )
                                            ]),
                                            _c("v-list-item-subtitle", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$keycloak.tokenParsed
                                                      .preferred_username
                                                  ) +
                                                  " "
                                              )
                                            ]),
                                            _c("v-list-item-subtitle", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("users.agency")
                                                  ) +
                                                  " : " +
                                                  _vm._s(
                                                    _vm.$keycloak.tokenParsed
                                                      .agency
                                                  ) +
                                                  " "
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c("v-divider"),
                                _c("ChangePassword", { ref: "changePsw" })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function({ on }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.signout()
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("mdi-export")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3026371101
                          )
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("global.disconnect")))
                          ])
                        ]
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1847039135
            )
          })
        : _vm._e(),
      _c("v-main", [_c("router-view")], 1),
      _c("RwFooter")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }